<template>
    <div class="file-upload-button">
        <v-btn variant="outlined" prepend-icon="mdi-upload" @click="triggerInput">
            {{ label }}
            <span v-if="selectedLabel" class="selected-label">{{ selectedLabel }}</span>
        </v-btn>
        <input
            ref="inputRef"
            type="file"
            :multiple="multiple"
            :accept="accept"
            style="display: none"
            @change="onFileChange"
        />
    </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue';

const props = defineProps({
    label: { type: String, required: true },
    multiple: { type: Boolean, default: false },
    accept: { type: String, default: '*/*' }
});

const emit = defineEmits(['file-selected']);
const inputRef = ref(null);
const selectedFiles = ref(null);

const selectedLabel = computed(() => {
    if (!selectedFiles.value) return null;
    return props.multiple
        ? `${selectedFiles.value.length} file(s)`
        : selectedFiles.value[0].name;
});

const triggerInput = () => inputRef.value.click();

const onFileChange = (e) => {
    const files = e.target.files;
    if (!files.length) return;
    selectedFiles.value = files;
    emit('file-selected', props.multiple ? Array.from(files) : files[0]);
};
</script>

<style scoped>
.file-upload-button {
    display: inline-flex;
    align-items: center;
}

.selected-label {
    margin-left: 8px;
    font-size: 12px;
    color: #b0bec5;
}
</style>